export default __webpack_public_path__ + "static/media/Armbands of the Membranous.5f31780b.jpg";